import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IAppDispatch} from "../../../store/store";
import {getRcnDataApi} from "../api/get_rcn_data_api";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {getRcnPriceStatsQuery} from "../utils/get_rcn_params";

export const fetchRcnData = (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const {district, region: cityRegion, pricesAvailableDate} = getState().report.price;
    const region = district ?? cityRegion;

    if (!region) {
        // Should be unreachable - fetchPriceReportRegion already redirects when no region resolves. Notify
        // Bugsnag if it happens anyway, since that means the pipeline order or upstream guard has drifted.
        notifyBugsnagClient({message: "fetchRcnData ran without a region in the store"}, "fetch_rcn_data");

        dispatch(enable301ResponseState(rpAppPath.prices.flats.base));

        return false;
    }

    // Default filters (all rooms, average) - what PricesDifferences asks for before the user touches anything.
    await dispatch(getRcnDataApi.endpoints.getRcnData.initiate(getRcnPriceStatsQuery(region.id, getPricesAvailableDate(pricesAvailableDate?.date))));

    return true;
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IAppDispatch} from "../../../store/store";
import {getRcnDataApi} from "../api/get_rcn_data_api";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {getRcnPriceStatsQuery} from "../utils/get_rcn_params";

export const fetchRcnData = (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const {district, region: cityRegion, pricesAvailableDate} = getState().report.price;
    const region = district ?? cityRegion;

    if (!region) {
        // Should be unreachable - fetchPriceReportRegion already redirects when no region resolves. Notify
        // Bugsnag if it happens anyway, since that means the pipeline order or upstream guard has drifted.
        notifyBugsnagClient({message: "fetchRcnData ran without a region in the store"}, "fetch_rcn_data");

        dispatch(enable301ResponseState(rpAppPath.prices.flats.base));

        return false;
    }

    // Default filters (all rooms, average) - what PricesDifferences asks for before the user touches anything.
    await dispatch(getRcnDataApi.endpoints.getRcnData.initiate(getRcnPriceStatsQuery(region.id, getPricesAvailableDate(pricesAvailableDate?.date))));

    return true;
};
